export default "__VITE_ASSET__df244a9d__"